const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  isProd: import.meta.env.VITE_IS_PROD,
  name: import.meta.env.VITE_NAME,
  // AI Builder visibility is build-time, per-env. Anything but an explicit
  // "true" hides it (fail-safe off) so it stays dormant in QA/prod until the
  // backend (function + APIM) is live there.
  aiBuilderEnabled: import.meta.env.VITE_AI_BUILDER_ENABLED === 'true',
  mcpAllowedReturnToPrefixes: (() => {
    try {
      return import.meta.env.VITE_MCP_ALLOWED_RETURN_TO_PREFIXES
        ? JSON.parse(import.meta.env.VITE_MCP_ALLOWED_RETURN_TO_PREFIXES)
        : [];
    } catch {
      return [];
    }
  })(),
};

export default config;
